<template>
    <div class="flex w-full gap-5 h-full laboratories-view justify-content-around overflow-hidden">
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">Laboratories</h2>
                <CustomButton label="New laboratory" @click="addNewLaboratory" />
            </div>
            <LaboratoryTable ref="laboratoryTable" v-model="selectedLaboratory" @showForm="showForm" />
        </div>
        <LibyanOrnament/>
        <div id="scrollToForm" class="section-details">
            <div class="flex justify-content-between align-items-center pr-1">
                <h2 class="page-header">{{ createMode ? "New Laboratory" : "Edit Laboratory" }}</h2>
                <CustomIconButton icon="pi pi-times" onlyIcon @click="hideForm" class="close-form-button" />
            </div>
            <LaboratoryForm :selectedLaboratory="selectedLaboratory" @change-element="reloadTable"
                            @createMode="(val) => createMode = val" @hideForm="hideForm" />
        </div>
    </div>
</template>

<script>
import CustomButton from "@/components/form/CustomButton.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import CustomIconButton from "@/components/form/CustomIconButton.vue";
import { ShowHideFormUtils } from "@/utils/ShowHideFormUtils";
import LaboratoryTable from "@/views/laboratory/components/LaboratoryTable.vue";
import LaboratoryForm from "@/views/laboratory/components/LaboratoryForm.vue";

export default {
    name: "LaboratoryListView",
    components: {
        LaboratoryTable,
        LaboratoryForm,
        LibyanOrnament,
        CustomButton,
        CustomIconButton,
    },

    data() {
        return {
            selectedLaboratory: {},
            createMode: true,
        };
    },

    mounted() {
        this.selectedLaboratory = this.getClearLaboratory();
    },

    methods: {
        getClearLaboratory() {
            return {
                id: null,
                name: "",
            };
        },
        reloadTable() {
            this.$refs.laboratoryTable.reloadTable();
            this.selectedLaboratory = this.getClearLaboratory();
        },
        addNewLaboratory() {
            ScrollToUtils.scrollToElement();
            this.$refs.laboratoryTable.addNewLaboratory();
            this.selectedLaboratory = this.getClearLaboratory();
            this.showForm();
        },
        showForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details");
        },
        hideForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details", true);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/theme/mytheme/variables";
.laboratories-view {
    @media screen and (max-width: 1200px) {
        flex-direction: column;
        align-items: center;
        .section-table, .section-details {
            width: 90% !important;
            overflow-y: unset;
            height: fit-content;
        }
        .close-form-button {
            display: none;
        }
    }
}
.section-table, .section-details {
    transition: 1s ease-in-out;
}
.section-details {
    width: 0;
    height: calc(100vh - 40px - $top-bar-height);;
    overflow-y: auto;
}
</style>
